import { addCpfMask, EmailLink, generateAvatarInitialsImage } from '@repo/ui';
import { GetAllPersonsFromEntityUseCaseInterface } from 'domain/usecases';
import { PROFILE_TYPE } from 'domain/value-objects/profile-type';
import { TableColumn } from 'react-data-table-component';

interface IProps {
  profileType: PROFILE_TYPE;
  navigate: (path: string) => void;
}

export const makePersonsFromEntityListColumns = ({
  profileType,
  navigate,
}: IProps): TableColumn<
  GetAllPersonsFromEntityUseCaseInterface.Result[number]
>[] => {
  return [
    {
      name: 'Nome',
      width: '25%',
      sortable: true,
      wrap: true,
      selector: (row) => row.name,
      cell: ({ personId, avatar, name }) => {
        const handleClick = () => {
          if (personId) {
            navigate(`/pessoas/${personId}?profileType=${profileType}`);
          } else {
            alert('Pessoa não encontrada');
          }
        };

        return (
          <div
            className="d-flex align-items-center gap-2"
            style={{ cursor: 'pointer' }}
            onClick={handleClick}
          >
            <img
              src={avatar || generateAvatarInitialsImage(name)}
              className="rounded-circle avatar-xs user-profile-image"
            />
            <p className="m-0">{name}</p>
          </div>
        );
      },
    },
    {
      name: 'CPF',
      width: '160px',
      sortable: true,
      selector: (row) => addCpfMask(row.cpf),
    },
    {
      name: 'E-mail',
      width: '270px',
      sortable: true,
      selector: (row) => row.email,
      cell: (row) => <EmailLink email={row.email} />,
    },
    profileType !== PROFILE_TYPE.DIRECTOR
      ? {
          name: 'Curso',
          sortable: true,
          selector: (row) => (row.course ? row.course : ''),
        }
      : {
          name: 'Profissão',
          sortable: true,
          selector: (row) => (row.profession ? row.profession : ''),
        },
  ];
};
